import { ModuleContent } from '../contract';

export type DividerLineStyle = 'solid' | 'dashed' | 'dotted';
export type DividerLineAlign = 'left' | 'center' | 'right';

/**
 * Content for the Divider module.
 * Line width/alignment control the visible divider inside the module wrapper.
 */
export type DividerModuleContent = {
	color?: string;
	thickness?: string;
	lineStyle?: DividerLineStyle;
	lineWidth?: string;
	lineAlign?: DividerLineAlign;
};

const validLineStyles: DividerLineStyle[] = ['solid', 'dashed', 'dotted'];
const validLineAlignments: DividerLineAlign[] = ['left', 'center', 'right'];

export function isDividerModuleContent(content: ModuleContent): content is DividerModuleContent {
	if (!content || typeof content !== 'object') return false;

	const dividerContent = content as DividerModuleContent;
	const hasKnownDividerKey =
		'color' in dividerContent ||
		'thickness' in dividerContent ||
		'lineStyle' in dividerContent ||
		'lineWidth' in dividerContent ||
		'lineAlign' in dividerContent;

	if (!hasKnownDividerKey && Object.keys(content).length > 0) {
		return false;
	}

	return (
		(dividerContent.color == null || typeof dividerContent.color === 'string') &&
		(dividerContent.thickness == null || typeof dividerContent.thickness === 'string') &&
		(dividerContent.lineWidth == null || typeof dividerContent.lineWidth === 'string') &&
		(dividerContent.lineStyle == null || validLineStyles.includes(dividerContent.lineStyle)) &&
		(dividerContent.lineAlign == null || validLineAlignments.includes(dividerContent.lineAlign))
	);
}
